<template>
    <div>
      <el-card v-loading='loading'>
        <div class="head">
          <el-input v-model="input" size="mini" style="width: 110px; margin-right: 10px" placeholder="请输入" clearable></el-input>
          <el-button type="primary" size="mini" @click="search" icon="el-icon-search">搜索</el-button>
          <el-button type="success" size="mini" @click="export_" icon="el-icon-download">导出数据</el-button>
          <el-button type="success" size="mini" @click="batch_operaction" icon="el-icon-edit">批量操作</el-button>
          <el-button type="success" size="mini" @click="plss" icon="el-icon-search">批量搜索</el-button>

          <div class="block">
            <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              style="width:320px;margin-right:10px"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>

          <!-- 请选择站点 -->
          <el-select size="mini" v-model="selectSite" multiple placeholder="请选择站点">
            <el-option
              v-for="item in Site"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择订单状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectListStatus" multiple placeholder="请选择订单状态">
            <el-option
              v-for="item in ListStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择商品状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectProductStatus" multiple placeholder="请选择商品状态">
            <el-option
              v-for="item in ProductStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择物流商 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectWLS" multiple placeholder="请选择物流商">
            <el-option
              v-for="item in WLS"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="CXDD" style="margin-left: 10px">查询订单</el-button>
        </div>

            <!-- :row-class-name="tableRowClassName" -->
          <el-table
            height="690"
            :data="tableData"
            border
            style="width: 100%;border: 1px solid #000000;margin-top: 20px;"
            :row-style="{height:'100px'}"
            :cell-style="{padding:0,borderColor:'#000000'}"
            :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
            @selection-change="selectionChange"
            v-loading="loading"
            :default-sort = "{prop: 'date_created_gmt', order: 'descending'}"
            @cell-dblclick='DblclickCell'
            >

            <!-- 全选按钮 -->
            <el-table-column
              align="center"
              type="selection"
              label="全选"
              width="40px">
            </el-table-column>

            <!-- 站点 -->
            <!-- :filter-method="filter" -->
            <!-- <el-table-column
              width="110px"
              label="站点">
              <template slot-scope="scope">
                <div>{{scope.row.site}}</div>
              </template>
            </el-table-column> -->

            <!-- 订单状态 -->
            <el-table-column
              width="90px"
              prop="status"
              label="订单状态"
              align="center"
              >
              <template slot-scope="scope">
                <el-tag
                :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
                disable-transitions>
                  {{scope.row.status}}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 订单ID -->
            <el-table-column prop="ID_" label="订单ID" width="60px" align="center">
            </el-table-column>

            <!-- 商品ID -->
            <el-table-column prop="product_id" label="商品ID" width="140px" align="center">
            </el-table-column>

            <!-- 下单时间 -->
            <el-table-column prop="date_created_gmt" label="下单时间" sortable width="95px" align="center">
            </el-table-column>

            <!-- 付款时间 -->
            <el-table-column prop="date_paid_gmt" label="付款时间" sortable width="95px" align="center">
            </el-table-column>

            <!-- SKU -->
            <!-- <el-table-column prop="sku" label="SKU" width="100px">
            </el-table-column> -->

            <!-- 国际物流单号 -->
            <el-table-column prop="int_no" label="国际物流单号" width="140px" align="center">
            </el-table-column>

            <!-- 图片 -->
            <el-table-column label="图片" width="50px" align="center">
              <template slot-scope="scope">
                <el-popover placement="right" width="500" trigger="click">
                  <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
                  <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
                </el-popover>
              </template>
            </el-table-column>

            <!-- 商品名称 -->
            <el-table-column prop="product_name" label="商品名称" width="80px" align="center">
            </el-table-column> 

            <!-- 定制信息 -->
            <el-table-column label="定制信息" width="" align="center">
              <template slot-scope="scope">
                <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
                <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
                <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
                <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
              </template>
            </el-table-column>

            <!-- 袖标 -->
            <el-table-column label="袖标" width="125" align="center">
              <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
                <span v-for="(item,index) in scope.row.armband" :key="index">
                    <el-popover placement="left" trigger="click" width="300">
                      <img :src="item" width="100%" style="background:gray" />
                      <img
                        slot="reference"
                        :src="item"
                        :alt="123"
                        width="48px" height="48px"
                        style="margin:1px;background:gray"
                      />
                    </el-popover>
                  </span>
              </template>
            </el-table-column>

            <!-- 配件 -->
            <el-table-column label="配件" width="125" align="center">
              <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
                <span v-for="(item,index) in scope.row.accessories" :key="index">
                    <el-popover placement="left" trigger="click" width="300">
                      <img :src="item" width="100%" />
                      <img
                        slot="reference"
                        :src="item"
                        :alt="123"
                        width="50px" height="50px"
                      />
                    </el-popover>
                  </span>
              </template>
            </el-table-column>

            <!-- 数量 -->
            <el-table-column prop="quantity" label="数量" width="40px" align="center">
            </el-table-column>

            <!-- 采购价 -->
            <el-table-column v-if="UN == 'cw' ? true: false" label="采购价" width="70px" align="center">
              <template slot-scope="scope">
                <span v-if='!scope.row.edit'>{{scope.row.cgj}}</span>
                <el-input size='mini' type='number' ref="CGJ" v-else v-model="scope.row.cgj" @blur='HandleBlur(scope.row)'>{{scope.row.cgj}}</el-input>
              </template>
            </el-table-column>

            <!-- 客户备注 -->
            <el-table-column prop="customer_note" label="客户备注" width="70px" align="center">
            </el-table-column>

            <!-- 商品备注 -->
            <el-table-column align="center" label="商品备注" width="100px" :filter-method="filternote" :filters="[{ text: '客服备注', value: '客服备注' }, { text: '仓库备注', value: '仓库备注' }, { text: '物流备注', value: '物流备注' }]">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 商品状态 -->
            <!-- :filter-method="filterproduct"
            :filters=""> -->
            <el-table-column prop="product_status" label="商品状态" width="130px" align="center">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                  <el-button
                   :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '仓库已发货' ? 'warning' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '待处理' ? 'info' : '')))))))))))" 
                   size="mini">
                      {{scope.row.product_status}}
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 价格 -->
            <el-table-column prop="price" label="价格" width="70px" align="center">
            </el-table-column>

            <!-- 物流方式 -->
            <el-table-column prop="shiptype" label="物流方式" width="60px" align="center">
            </el-table-column>

            <!-- 物流商 -->
            <!-- :filter-method = "filterWlS" 
            :filters="[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'}]" -->
            <el-table-column prop="wls" label="物流商" width="50px" align="center">
            </el-table-column>

            <!-- 是否加急 -->
            <el-table-column label="是否加急" width="55">
              <template slot-scope="scope">
                <el-radio-group @input='HandleRadio(scope.row)' v-model="scope.row.isurgent">
                  <el-radio label="是" style="margin-bottom:10px">是</el-radio>
                  <el-radio label="">否</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            
            <!-- 操作 编辑 查看 -->
            <el-table-column label="操作" width="50px" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="edit(scope.$index, scope.row)"
                  circle
                >
                </el-button>
                <el-button
                  style="margin-left: 0;margin-top: 10px;"
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  @click="look(scope.$index, scope.row)"
                  circle
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 商品信息弹出框 -->
          <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
            <el-form :model="form">
              <el-form-item label="商品ID" :label-width="formLabelWidth">
                <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="图片" :label-width="formLabelWidth">
                <el-input v-model="form.img" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="商品名称" :label-width="formLabelWidth">
                <el-input v-model="form.product_name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="客服备注" :label-width="formLabelWidth">
                <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注"></el-input>
              </el-form-item>
              <el-form-item label="仓库备注" :label-width="formLabelWidth">
                <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注"></el-input>
              </el-form-item>
              <el-form-item label="物流备注" :label-width="formLabelWidth">
                <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注"></el-input>
              </el-form-item>
              <el-form-item label="国内快递单号" :label-width="formLabelWidth">
                <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
              </el-form-item>
              <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form.product_status" placeholder="请选择商品状态">
                  <el-option label="待审核" value="待审核"></el-option>
                  <el-option label="待发货" value="待发货"></el-option>
                  <el-option label="待发货-制作中" value="待发货-制作中"></el-option>
                  <el-option label="待处理" value="待处理"></el-option>
                  <el-option label="仓库已发货" value="仓库已发货"></el-option>
                  <el-option label="已到货代" value="已到货代"></el-option>
                  <el-option label="物流已发货" value="物流已发货"></el-option>
                  <el-option label="异常" value="异常"></el-option>
                  <el-option label="暂停" value="暂停"></el-option>
                  <el-option label="已取消" value="已取消"></el-option>
                  <el-option label="已退款" value="已退款"></el-option>
                  <el-option label="缺货" value="缺货"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="袖标" :label-width="formLabelWidth">
                <el-input v-model="form.armband" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="配件" :label-width="formLabelWidth">
                <el-input v-model="form.accessories" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="字号" :label-width="formLabelWidth">
                <el-input v-model="form.word_no" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="尺码" :label-width="formLabelWidth">
                <el-input v-model="form.size" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
          </el-dialog>

          <!-- 导出数据二次确认框 -->
          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>您确认要导出选中的数据吗?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleUpload">确 定</el-button>
            </span>
          </el-dialog>
          

          <!-- 批量搜索对话框 -->
          <el-dialog
            title="商品id和(或者)订单id"
            :visible.sync="plss_"
            width="50%">
            <el-input type="textarea" :rows="10" placeholder="请输入商品id和(或者)订单id" v-model="abc" show-word-limit maxlength="999999999999999"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="plss_ = false">取 消</el-button>
              <el-button type="primary" @click="qdplss">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 批量操作对话框 -->
          <el-dialog title="物流商" :visible.sync="dialog_">
            <el-form :model="form_">
              <el-form-item label="物流商" :label-width="formLabelWidth">
                <el-select v-model="form_.wls" placeholder="请选择物流商">
                  <el-option label="ST" value="ST"></el-option>
                  <el-option label="V20" value="V20"></el-option>
                  <el-option label="66" value="66"></el-option>
                  <el-option label="WSY" value="WSY"></el-option>
                  <el-option label="HB" value="HB"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialog_ = false">取 消</el-button>
              <el-button type="primary" @click="QD">确 定</el-button>
            </div>
          </el-dialog>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pss"
          :page-size="ps"
          :total="Total"
          layout="total, sizes, prev, pager, next, jumper"
          style="display:flex; justify-content: center;">
        </el-pagination>
      </el-card>


    </div>
</template>

<script>
import { getProduct,Edit,plczwls,getProductList,getProductPage,czjl,changeProductStatus,getPT,hqsj,GPL,ckpllrspcgj,ChangeSpeed } from '../../api/api'
import table2excel from 'js-table2excel'
import imageToBase64 from 'image-to-base64/browser';
export default {
  // inject: ['reload'],
  data() {
    return {

      UN:'',

      abc:'',
      plss_:false,

      currentPage: 1,//默认第几页
      pss:[50,100,200,500,700,1000,3000],
      ps:100,//默认每页条数
      Total:0,

      Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'top-w', value: 'top-w' }],
      selectSite:[],//筛选站点
      ListStatus:[{ label: '待付款', value: '待付款' }, { label: '正在处理', value: '正在处理' }, { label: '保留', value: '保留' }, { label: '已完成', value: '已完成' }, { label: '已取消', value: '已取消' }, { label: '已退款', value: '已退款' }, { label: '失败订单', value: '失败订单' }],
      selectListStatus:['正在处理'],//筛选订单状态
      ProductStatus:[{ text: '待审核', value: '待审核' }, { text: '待发货', value: '待发货' }, { text: '待发货-制作中', value: '待发货-制作中' }, {text: '待处理', value: '待处理'}, { text: '仓库已发货', value: '仓库已发货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }],//商品状态
      selectProductStatus:[],//筛选商品状态
      WLS:[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'},{text:'HB', value:'HB'}],//物流商
      selectWLS:[],//筛选物流商

      dialogVisible:false,
      dialogFormVisible: false,
      dialog_:false,
      form: {
        product_id: '',      //商品ID
        img:'',              //图片
        product_name: '',    //商品名称
        product_note: '',    //商品备注
        warehouse_note: '',  //仓库备注
        logistics_note: '',  //物流备注
        inland_number: '',   //国内物流单号
        product_status: '',  //商品状态
        armband: '',         //袖标
        accessories: '',     //配件
        word_no: '',         //字号
        size:''              //尺码
      },
      form_:{
        product_id: [],
        wls: ''
      },
      formLabelWidth: '120px',
      tableData: [],//页面展示
      loading: true,
      Data_: [],//批量选中的数据(导出或者修改)
      input: "",
      value1:[],
      orig:{}
    }
  },

  created () {
    var un = window.localStorage.getItem('un');
    this.UN = un;
    if(un == '' || un == null || un == undefined){
      this.loading = true;
      return false;
    }

    var params = {
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      ProductStatus:this.selectProductStatus,
      WLS:this.selectWLS,
      date_created_gmt:this.value1
    }
    getProductPage(params).then(res => {
      this.Total = res.length;
    })

    var params = {
      Limit:this.ps,
      Offset:0,
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      ProductStatus:this.selectProductStatus,
      WLS:this.selectWLS,
      date_created_gmt:this.value1
    }
    getProductList(params).then(res => {
      for (const i of res) {
        if(i.armband == null || i.armband == undefined || i.armband == ''){
          i.armband = '无';
        }
        else if(i.armband.charAt(0) == "h"){
          i.armband = i.armband.split(",");
        }

        if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
          i.accessories = '无';
        }
        else if(i.accessories.charAt(0) == "h"){
          i.accessories = i.accessories.split(",");
        }

        if(i.edit == undefined){
          i.edit = false;
        }

      }
      this.tableData = res;
      this.loading = false;
    })

  },
  
  methods: {

    // 设置表格行高亮
    tableRowClassName({row,rowIndex}){
      if(row.ID_ % 2 === 0){
        return "yellow"
      }else if(row.ID_ % 2 === 1){
        return "red"
      }
    },

    // 选择是否加急
    HandleRadio(row){
      var IsUrgent = {
        product_id: row.product_id,
        isurgent: row.isurgent
      }
      ChangeSpeed(IsUrgent).then(res => {
        if(res.code == 200){
          this.$message({
            message:res.msg,
            type:'success'
          })
        }else if(res.code == 404){
          this.$message({
            message:res.msg,
            type:'error'
          })
        }
      })
    },

    // 双击单元格显示input输入框
    // DblclickCell(row, column, cell, event){
    DblclickCell(row){
      this.$set(row,'edit',true);
      // input输入框自动获取焦点
      this.$nextTick(() => {
        this.$refs.CGJ.focus();
      })
    },

    // input输入框失去焦点
    HandleBlur(row){
      this.$set(row,'edit',false);
      this.upCgj = {
        cgj:row.cgj,
        product_id:row.product_id
      }
      if(row.cgj == ''){
        this.$message({
          message:'采购价为空,请先输入采购价',
          type:'warning'
        })
        return false
      }
      ckpllrspcgj(this.upCgj).then(res => {
        if(res.code == 200){
          this.$message({
            message:res.msg,
            type:'success'
          })
        }else if(res.code == 404){
          this.$message({
            message:res.msg,
            type:'warning'
          })
        }
      })
    },

    // sumByType(arr) {
    //   let obj = {}
    //   arr.forEach((item) => {
    //       console.log(obj, item.type, item.value)
    //       if (obj[item.type] !== undefined) {
    //           obj[item.type] += item.value
    //       } else {
    //           obj[item.type] = item.value
    //       }
    //   })
    //   return Object.keys(obj).map((key) => {
    //       return {
    //           type: key,
    //           value: obj[key]
    //       }
    //   })
    // },

    // 批量搜索
    plss(){
      this.plss_ = true;
    },

    // 确定批量搜索
    qdplss(){
      this.plss_ = false;
      // console.log(this.abc,typeof(this.abc));
      if(this.abc == '' || this.abc == null || this.abc == undefined){
        this.$message({
          message:'搜索内容为空!!!',
          type:'warning'
        })
        this.dialog_ = false;
        return false;
      }
      // var a = this.abc.replace(/madrid-shop/g,'madrid-shop,').replace(/cuirz/g,'cuirz,').replace(/nihonbro/g,'nihonbro,').replace(/jleague-shop/g,'jleague-shop,').replace(/supermaillot/g,'supermaillot,').replace(/fortmaillot/g,'fortmaillot,').replace(/kickitshirts/g,'kickitshirts,').replace(/mailloten/g,'mailloten,').replace(/honorjersey/g,'honorjersey,').replace(/ligafoot/g,'ligafoot,').replace(/beazl/g,'beazl,').replace(/top-w/g,'top-w,').replace(/\n/g,',');
      var a = this.abc.replace(/\n/g,',');
      // console.log(a);
      const Plss = this.$router.resolve({ path: "/home/search_", query: { product_id: a}});
      window.open(Plss.href, '_blank');
      
    },

    //复选框
    selectionChange(selection){
      // console.log(selection[k].pro_det);
      // console.log(typeof(selection[0].armband) == 'object' ? '按图' : '123');
      for(var k = 0;k < selection.length;k++){

        // 定制信息
        if(selection[k].pro_det == undefined){
          // var pj = "配件:",zh = "字号:",cm = "尺码:",xb = "袖标:";
          var zh = "字号:",cm = "尺码:";
          // pj = pj.fontcolor('red');
          // pj = pj.fontsize(3);
          // pj = pj.bold();
          zh = zh.fontcolor('#00ff00');
          zh = zh.fontsize(3);
          zh = zh.bold();
          cm = cm.fontcolor('blue');
          cm = cm.fontsize(3);
          cm = cm.bold();
          // xb = xb.fontcolor('cyan');
          // xb = xb.fontsize(3);
          // xb = xb.bold();
          // selection[k].pro_det = '<br/>配件:' + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + `<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:` + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
          // selection[k].pro_det = pj + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + zh + `${selection[k].word_no}` + cm + `${selection[k].size}` + xb + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
          selection[k].pro_det = zh + `${selection[k].word_no}` + cm + `${selection[k].size}`;
        }

        // 格式化支付时间
        // selection[k].date_paid_gmt = this.$moment(selection[k].date_paid_gmt).format('YY-MM-DD');

        // 整合袖标图片
        if(typeof(selection[k].armband) == 'object'){
          // 将袖标字符串转化为数组
          var ddd = selection[k].armband;
          // 袖标数组长度
          var ttt = selection[k].armband.length;
          if(ttt == 0){
            if(selection[k].armband1 == undefined){
              selection[k].armband1 = '无';
            }
            if(selection[k].armband2 == undefined){
              selection[k].armband2 = "无";
            }
            if(selection[k].armband3 == undefined){
              selection[k].armband3 = "无";
            }
            if(selection[k].armband4 == undefined){
              selection[k].armband4 = "无";
            }
            if(selection[k].armband5 == undefined){
              selection[k].armband5 = "无";
            }
            if(selection[k].armband6 == undefined){
              selection[k].armband6 = "无";
            }
          }
          else if(ttt == 1){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = "无";
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }
            }
          }
          else if(ttt == 2){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 3){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 4){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 5){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 6){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }else if(i == 5){
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = ddd[i];
                }
              }
            }
          }
        }

        // 整合配件图片
        if(typeof(selection[k].accessories) == 'object'){
          var sss = selection[k].accessories;
          var ggg = selection[k].accessories.length;
          if(ggg == 0){
            if(selection[k].accessories1 == undefined){
              selection[k].accessories1 = '无';
            }
            if(selection[k].accessories2 == undefined){
              selection[k].accessories2 = '无';
            }
          }
          else if(ggg == 1){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = '无';
                }
              }
            }
          }
          else if(ggg == 2){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
              }else if(p == 1){
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = sss[p];
                }
              }
            }
          }
        }

      }
      
      for(let i of this.Data_){
        imageToBase64(i.img).then((response) => 
          {
            // console.log('data:image/jpeg;base64,' + response);
            i.img = 'data:image/jpeg;base64,' + response
          }).catch((error) => 
          {
            console.log(error);
          })
      }
      this.Data_ = selection;
      // console.log(this.Data_);
    },

    //设置每页几条
    handleSizeChange(val) {
      this.loading = true;
      this.ps = val;
      var limit = val;
      var offset = (this.currentPage - 1) * val;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:this.value1
      }
      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    //前往第几页
    handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      var limit = this.ps;
      var offset = (val - 1) * this.ps;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:this.value1
      }
      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    // 查询订单
    CXDD(){
      this.loading = true;
      var params = {
        Limit:this.ps,
        Offset:(this.currentPage - 1) * this.ps,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:this.value1
      }
      // console.log(params);
      getProductList(params).then(res => {
        // console.log(res);
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })
      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:this.value1
      }
      getProductPage(params).then(res => {
        this.Total = res.length;
      })
    },

    // X(导出数据)
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    //导出数据(二次确认)
    export_(){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      };
      this.dialogVisible = true;
    },

    //导出数据(确认导出)
    handleUpload(){
      this.dialogVisible = false;
      if(this.Data_.length == 0){
        this.$message({
          message: "导出数据为空,请先选中您要导出的数据",
          type: "warning",
          showClose: true
        })
        return false;
      }else{
        for(var i = 0;i < this.Data_.length;i++){
          this.Data_[i].date_created_gmt = this.$moment(this.Data_[i].date_created_gmt).format('YY-MM-DD');
          this.Data_[i].date_paid_gmt = this.$moment(this.Data_[i].date_paid_gmt).format('YY-MM-DD');
          this.Data_[i].int_no = '&nbsp;' + this.Data_[i].int_no;
        }
      }
      // console.log(this.Data_);

      if(window.localStorage.getItem('un') == 'cw'){
        let column = [
          {
            title: '订单状态',
            key: 'status',
            type: 'text'
          },
          {
            title: '订单ID',
            key: 'ID_',
            type: 'text'
          },
          {
            title: '站点',
            key: 'site',
            type: 'text'
          },
          {
            title: '商品id',
            key: 'product_id',
            type: 'text'
          },
          {
            title: '付款时间',
            key: 'date_paid_gmt',
            type: 'text'
          },
          {
            title: '国际物流单号',
            key: 'int_no',
            type: 'text'
          },
          {
            title: '产品图片',
            key: 'img',
            type: 'image',
            width: 120,
            height: 110
          },
          {
            title: '产品名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '定制信息',
            key: 'pro_det',
            type: 'text'
          },
          {
            title: '袖标1',
            key: 'armband1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标2',
            key: 'armband2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标3',
            key: 'armband3',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标4',
            key: 'armband4',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标5',
            key: 'armband5',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标6',
            key: 'armband6',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件1',
            key: 'accessories1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件2',
            key: 'accessories2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '数量',
            key: 'quantity',
            type: 'text'
          },
          {
            title: '采购价',
            key: 'cgj',
            type: 'text'
          },
          {
            title: '客服备注',
            key: 'product_note',
            type: 'text',
          },
          {
            title: '仓库备注',
            key: 'warehouse_note',
            type: 'text',
          },
          {
            title: '物流备注',
            key: 'logistics_note',
            type: 'text',
          },
          {
            title: '商品状态',
            key: 'product_status',
            type: 'text'
          },
          {
            title: '价格',
            key: 'price',
            type: 'text'
          },
          {
            title: '物流方式',
            key: 'shiptype',
            type: 'text'
          },
          {
            title: '物流商',
            key: 'wls',
            type: 'text'
          },
          {
            title: '是否加急',
            key: 'isurgent',
            type: 'text'
          },
        ]
        table2excel(column, this.Data_, "订单列表.xls");
      }else{
        let column = [
          {
            title: '站点',
            key: 'site',
            type: 'text'
          },
          {
            title: '商品id',
            key: 'product_id',
            type: 'text'
          },
          {
            title: '订单id', 
            key: 'ID_',
            type: 'text'
          },
          {
            title: '支付时间', 
            key: 'date_paid_gmt',
            type: 'text'
          },
          {
            title: '产品图片',
            key: 'img',
            type: 'image',
            width: 120,
            height: 110
          },
          {
            title: '产品名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '定制信息',
            key: 'pro_det',
            type: 'text'
          },
          {
            title: '袖标1',
            key: 'armband1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标2',
            key: 'armband2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标3',
            key: 'armband3',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标4',
            key: 'armband4',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标5',
            key: 'armband5',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标6',
            key: 'armband6',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件1',
            key: 'accessories1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件2',
            key: 'accessories2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '客户备注',
            key: 'customer_note',
            type: 'text'
          },
          {
            title: '数量',
            key: 'quantity',
            type: 'text'
          },
          {
            title: '物流商',
            key: 'wls',
            type: 'text'
          },
          {
            title: '客服备注',
            key: 'product_note',
            type: 'text',
          },
          {
            title: '仓库备注',
            key: 'warehouse_note',
            type: 'text',
          },
          {
            title: '物流备注',
            key: 'logistics_note',
            type: 'text',
          },
          {
            title: '商品状态',
            key: 'product_status',
            type: 'text'
          },
          {
            title: '国际物流单号',
            key: 'int_no',
            type: 'text'
          }
        ]
        table2excel(column, this.Data_, "订单列表.xls");
      }

      
      var t = new Date();
      var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss")
      var lll = this.Data_.length;
      var abc = [];
      for(var i of this.Data_){
        abc.push(i.product_id);
      }
      var nba = abc.toString();
      var params = {
        person:window.localStorage.getItem('un'),
        time:time_,
        event:'导出了' + nba + '共' + lll + '件商品。'
      }
      czjl(params).then(res => {});
    },

    //编辑
    edit(index,row){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      };

      this.form = {
        product_id: row.product_id,
        img: row.img,
        product_name: row.product_name,
        product_note: row.product_note,
        warehouse_note: row.warehouse_note,
        logistics_note: row.logistics_note,
        inland_number: row.inland_number,
        product_status: row.product_status,
        armband: row.armband,
        accessories: row.accessories,
        word_no: row.word_no,
        size: row.size
      }
      this.dialogFormVisible = true;
      getProduct(this.form.product_id).then(res => {
        // console.log(res);
        this.orig = res[0];
      })
    },

    //取消编辑
    cancel(){
      this.dialogFormVisible = false;
      this.$message('取消编辑成功！！！');
    },

    //确定编辑
    confirm(){
      // console.log(this.form.inland_number);
      if((this.form.inland_number == '' || this.form.inland_number == undefined) && this.form.product_status == "仓库已发货"){
        this.$message({
          message:'仓库已发货时，国内快递单号不能为空！！！',
          type:'error'
        })
        return false;
      }else{
        var timee = new Date();
        var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
        var params = {
          product_id: this.form.product_id,
          img: this.form.img,
          product_name: this.form.product_name,
          product_note:this.form.product_note,
          warehouse_note:this.form.warehouse_note,
          logistics_note:this.form.logistics_note,
          inland_number:this.form.inland_number,
          product_status:this.form.product_status,
          armband:this.form.armband,
          accessories:this.form.accessories,
          word_no:this.form.word_no,
          size:this.form.size,
          person:window.localStorage.getItem('un'),
          time:timeee
        };
        Edit(params).then(res => {
          if(res.code === 200){
            this.loading = true;
            for(var i of this.tableData){
              if(i.product_id == this.form.product_id){
                i.img = this.form.img;
                i.product_name = this.form.product_name;
                i.product_note = this.form.product_note;
                i.warehouse_note = this.form.warehouse_note;
                i.logistics_note = this.form.logistics_note;
                i.inland_number = this.form.inland_number;
                i.product_status = this.form.product_status;
                i.armband = this.form.armband;
                i.accessories = this.form.accessories;
                i.word_no = this.form.word_no;
                i.size = this.form.size;
              }
            }
            this.loading = false;
            this.$message({
              message: '编辑成功！！！',
              type: 'success'
            });

            var t = new Date();
            var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss");
            var ah = false;
            if(this.orig.img != params.img || this.orig.product_name != params.product_name || this.orig.product_note != params.product_note || this.orig.warehouse_note != params.warehouse_note || this.orig.logistics_note != params.logistics_note || this.orig.product_status != params.product_status || this.orig.armband != params.armband || this.orig.accessories != params.accessories || this.orig.word_no != params.word_no || this.orig.size != params.size){
              var speak = '将' + this.orig.product_id + '的';
              ah = true;
            }

            // 1
            if(this.orig.img != params.img){
              speak += '图片由' + this.orig.img + '改为' + params.img;
            }
            // 2
            if(this.orig.product_name != params.product_name){
              speak += '商品名称由' + this.orig.product_name + '改为' + params.product_name;
            }
            // 3
            if((this.orig.product_note != params.product_note) && (this.orig.product_note != '' && this.orig.product_note != null && this.orig.product_note != 'null' && this.orig.product_note != undefined)){
              speak += '客服备注由' + this.orig.product_note + '改为' + params.product_note;
            }
            // 4
            if((this.orig.warehouse_note != params.warehouse_note) && (this.orig.warehouse_note != '' && this.orig.warehouse_note != null && this.orig.warehouse_note != 'null' && this.orig.warehouse_note != undefined)){
              speak += '仓库备注由' + this.orig.warehouse_note + '改为' + params.warehouse_note;
            }
            // 5
            if((this.orig.logistics_note != params.logistics_note) && (this.orig.logistics_note != '' && this.orig.logistics_note != null && this.orig.logistics_note != 'null' && this.orig.logistics_note != undefined)){
              speak += '物流备注由' + this.orig.logistics_note + '改为' + params.logistics_note;
            }
            // 6
            if(this.orig.product_status != params.product_status){
              speak += '商品状态由' + this.orig.product_status + '改为' + params.product_status;
            }
            // 7
            if((this.orig.armband != params.armband) && (this.orig.armband != '' && this.orig.armband != null && this.orig.armband != 'null' && this.orig.armband != undefined)){
              speak += '袖标由' + this.orig.armband + '改为' + params.armband;
            }
            // 8
            if((this.orig.accessories != params.accessories) && (this.orig.accessories != '' && this.orig.accessories != null && this.orig.accessories != 'null' && this.orig.accessories != undefined)){
              speak += '配件由' + this.orig.accessories + '改为' + params.accessories;
            }
            // 9
            if((this.orig.word_no != params.word_no) && (this.orig.word_no != '' && this.orig.word_no != null && this.orig.word_no != 'null' && this.orig.word_no != undefined)){
              speak += '字号由' + this.orig.word_no + '改为' + params.word_no;
            }
            // 10
            if(this.orig.size != params.size){
              speak += '尺码由' + this.orig.size + '改为' + params.size;
            }
            if(ah == true){
              var post = {
                person:window.localStorage.getItem('un'),
                time:time_,
                event:speak
              }
              // console.log(post);
              czjl(post).then(res => {});
            }

            // if(this.orig.product_status != params.product_status){
            //   var jjj = {
            //     person:window.localStorage.getItem('un'),
            //     time:time_,
            //     product_id:this.form.product_id,
            //     product_status:params.product_status
            //   }
            //   // console.log(jjj);
            //   changeProductStatus(jjj).then(res => {});
            // }
            
            

            // getProduct(this.form.product_id).then(res => {
            //   console.log(res);
            // })
          }else{
            this.$message({
              message: '编辑失败！！！',
              type: 'error'
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.dialogFormVisible = false;

        // var t = new Date();
        // var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss");
        // var speak = '';
        // if(this.orig.img != params.img){
        //   speak += '将' + this.orig.product_id + '的图片由' + this.orig.img + '改为' + params.img;
        // }
        // if(this.orig.product_name != params.product_name){
        //   speak += '将' + this.orig.product_id + '的商品名称由' + this.orig.product_name + '改为' + params.product_name;
        // }
        // if(this.orig.product_note != params.product_note){
        //   speak += '将' + this.orig.product_id + '的客服备注由' + this.orig.product_note + '改为' + params.product_note;
        // }
        // if(this.orig.product_note != params.warehouse_note){
        //   speak += '将' + this.orig.product_id + '的仓库备注由' + this.orig.warehouse_note + '改为' + params.warehouse_note;
        // }
        // if(this.orig.logistics_note != params.logistics_note){
        //   speak += '将' + this.orig.product_id + '的物流备注由' + this.orig.logistics_note + '改为' + params.logistics_note;
        // }
        // if(this.orig.product_status != params.product_status){
        //   speak += '将' + this.orig.product_id + '的商品状态由' + this.orig.product_status + '改为' + params.product_status;
        // }
        // if(this.orig.armband != params.armband){
        //   speak += '将' + this.orig.product_id + '的袖标由' + this.orig.armband + '改为' + params.armband;
        // }
        // if(this.orig.accessories != params.accessories){
        //   speak += '将' + this.orig.product_id + '的配件由' + this.orig.accessories + '改为' + params.accessories;
        // }
        // if(this.orig.word_no != params.word_no){
        //   speak += '将' + this.orig.product_id + '的字号由' + this.orig.word_no + '改为' + params.word_no;
        // }
        // if(this.orig.size != params.size){
        //   speak += '将' + this.orig.product_id + '的尺码由' + this.orig.size + '改为' + params.size;
        // }
        // var post = {
        //   person:window.localStorage.getItem('un'),
        //   time:time_,
        //   event:speak
        // }
        // console.log(post);
        // czjl(post).then(res => {});

      }
      // // this.reload();
      // console.log(this.orig,params);
      
    },

    //查看详情
    look(index, row){
      const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
      window.open(routeData.href, '_blank');
    },

    //批量操作(修改物流商)
    batch_operaction(){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      }else if(this.Data_.length == 0){
        this.$message({
          message:'请先选择要操作的商品！！！',
          type:'warning'
        })
      }else{
        this.dialog_ = true;
      }
    },

    // 批量操作(确定)
    QD(){
      this.dialog_ = false;
      // if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
      //   this.$message({
      //     message: "账号密码丢失，请重新登录",
      //     type: "warning",
      //     showClose: true
      //   })
      //   this.loading = true;
      //   return false;
      // };
      for(var i of this.Data_){
        if(this.form_.wls == '' || this.form_.wls == null || this.form_.wls == undefined){
          this.$message({
            message:'未选择物流商！！！',
            type:'warning'
          })
          return false;
        }else{
          i.wls = this.form_.wls;
          this.form_.product_id.push(i.product_id);
        }
      }
      var params = this.form_;
      plczwls(params).then(res => {});
      this.$message({
        message:'操作成功！！！',
        type:'success'
      })
      var t = new Date();
      var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss")
      var lll = this.Data_.length;
      var abc = [];
      for(var i of this.Data_){
        abc.push(i.product_id);
      }
      var nba = abc.toString();
      var name = this.form_.wls;
      // console.log(time_,lll,nba,name);
      var post = {
        person:window.localStorage.getItem('un'),
        time:time_,
        event:'批量操作了' + nba + '共' + lll + '件商品的物流商为' + name + '。'
      }
      czjl(post).then(res => {});
    },
    
    // // 店铺筛选
    // filter(value, row) {
    //   return row.site === value;
    // },

    // // 状态筛选
    // filterTag(value, row) {
    //   return row.status === value;
    // },

    // 商品备注筛选
    filternote(value, row) {
      if(value == '客服备注'){
        return row.product_note != '' && row.product_note != null;
      }else if(value == '仓库备注'){
        return row.warehouse_note != '' && row.warehouse_note != null;
      }else if(value == '物流备注'){
        return row.logistics_note != '' && row.logistics_note != null;
      }
    },

    // // 商品状态筛选
    // filterproduct(value, row){
    //   return row.product_status === value;
    // },

    // // 物流商筛选
    // filterWlS(value, row){
    //   return row.wls === value;
    // },

    //搜索
    search(){
      if(this.input === '' || this.input === null || this.input === undefined){
        this.$message({
          message: '搜索内容为空！！！',
          type: 'error'
        });
        return false;
      }
      const search__ = this.$router.resolve({ path: "/home/search_", query: { id: this.input}});
      window.open(search__.href, '_blank');
      // this.loading = true;
      // getProduct().then(res => {
      //   var arr = []
      //   for(var i = 0;i < res.length;i++){
      //     if(res[i].ID_ == this.input){
      //       if(res[i].armband == '' || res[i].armband == null){
      //         res[i].armband = "无";
      //       }
      //       if(res[i].accessories == '' || res[i].accessories == null){
      //         res[i].accessories = "无";
      //       }
      //       if(res[i].word_no == '' || res[i].word_no == null){
      //         res[i].word_no = "无";
      //       }
      //       arr.push(res[i]);
      //     }
      //   }
      //   this.tableData = arr;
      //   if(arr.length == 0){
      //     this.$message({
      //       showClose: true,
      //       message: '您查找的订单不存在，请核对后重新查找',
      //       type: 'warning'
      //     });
      //   }
      //   this.loading = false;
      // })
    },

    //重置
    reset(){
      this.loading = true;
      this.input = "";
      getProduct().then(res => {
        for(var i = 0;i < res.length;i++){
          if(res[i].armband == '' || res[i].armband == null){
            res[i].armband = "无";
          }
          if(res[i].accessories == '' || res[i].accessories == null){
            res[i].accessories = "无";
          }
          if(res[i].word_no == '' || res[i].word_no == null){
            res[i].word_no = "无";
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    //时间格式化
    utc2timestamp(utc_datetime) {
      // 处理成为时间戳
      var timestamp = new Date(Date.parse(utc_datetime));
      timestamp = timestamp.getTime();
      return timestamp;
    },

    //时间范围筛选
    block(time){
      this.loading = true;
      if(!time){
        this.value1 = [];
        this.loading = false;
        return false
      }
      var timestamp,timestamp_ = '';
      timestamp = Date.parse(this.value1[0]);
      timestamp_ = Date.parse(this.value1[1]);
      // console.log(timestamp,timestamp_);
      var arr = [];
      GPL().then(res => {
        for(var i = 0;i < res.length;i++){
          if(res[i].date_paid_gmt == null || res[i].date_paid_gmt == undefined || res[i].date_paid_gmt == '无'){
            continue
          }else{
            var Time = this.utc2timestamp(res[i].date_paid_gmt);
            if(Time > timestamp && Time < timestamp_){
              arr.push(res[i]);
            }
          }
        }

        for (const i of arr) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }

        this.tableData = arr;
        this.Total = arr.length;
        this.loading = false;
      })
    },
  },
  
}
</script>

<style lang="scss" scoped>

  /deep/ .el-table .yellow{
    background: #c7e2ff;
    color: #000000;
    &:hover .el-table__cell{
      background: #c7e2ff;
      font-weight: bolder;
    }
  }

  /deep/ .el-table .red{
    color: #000000;
    &:hover .cell{
      font-weight: bolder;
    }
  }

  .head{
    margin-bottom: 20px;
    .block{
      display: inline-block;
      margin-left: 10px;
    }
  }
  // 隐藏数字输入框后面的上下调节按钮
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 16px; // 横向滚动条
    height: 16px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 10px;
  }
</style>
<style lang="scss">
  .el-tooltip__popper{
    max-width: 200px !important;
  }
</style>